import React, {Component} from 'react';
import ValidationError from '../../helpers/ValidationError';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';

import Logo from '../../assets/logo.png';
import Input from '../../components/UI/Input/Input';
import Button from '../../components/UI/Button/Button';
import Spinner from '../../components/UI/Spinner/Spinner';
import * as actions from '../../store/actions/index';

const controlOrders = [
    'email',
    'password'
];

class Login extends Component {

    state = {
        controls: {
            email: {
                elementType: 'input',
                elementConfig: {
                    type: 'email',
                    placeholder: 'Email Address'
                },
                value: '',
                validation: {
                    required: true,
                    isEmail: true
                },
                validationMessage: 'Please enter a valid Email',
                valid: false,
                touched: false
            },
            password: {
                elementType: 'input',
                elementConfig: {
                    type: 'password',
                    placeholder: 'Password'
                },
                value: '',
                validation: {
                    required: true,
                    minLength: 6
                },
                validationMessage: 'Please enter a valid Password',
                valid: false,
                touched: false
            }
        },
        formIsValid: true
    }

    componentDidMount() {
        if (this.props.authRedirectPath !== '/') {
            this.props.onSetAuthRedirectPath();
        }
    }

    loginHandler = ( event ) => {
        event.preventDefault();
        this.props.onAuth( this.state.controls.email.value, this.state.controls.password.value, this.state.isSignup );
    }

    inputChangedHandler = ( event, controlName ) => {
        const updatedControls = {
            ...this.state.controls,
            [controlName]: {
                ...this.state.controls[controlName],
                value: event.target.value,
                valid: ValidationError(event.target.value, this.state.controls[controlName].validation),
                touched: true
            }
        };
        let formIsValid = true;
        for(let inputIdentifier in updatedControls) {
            formIsValid = updatedControls[inputIdentifier].valid && formIsValid;
        }
        this.setState({ 
            controls: updatedControls,
            formIsValid: !formIsValid
        });
    }

    render() {
        const formElementsArray = [];
        for ( let i = 0; i < controlOrders.length; i++ ) {
            const control = controlOrders[i];
            formElementsArray.push( {
                id: control,
                index: i,
                config: this.state.controls[control]
            } );
        }
        
        let form = formElementsArray.map( formElement => (
            <Input
                key={formElement.id}
                elementType={formElement.config.elementType}
                elementConfig={formElement.config.elementConfig}
                errorMessage={formElement.config.validationMessage}
                value={formElement.config.value}
                invalid={!formElement.config.valid}
                shouldValidate={formElement.config.validation}
                touched={formElement.config.touched}
                changed={( event ) => this.inputChangedHandler( event, formElement.id )} />
        ) );

        if (this.props.loading) {
            form = <Spinner />
        }

        let errorMessage = null;

        if (this.props.error) {
            errorMessage = (
                <p className="login-box-msg" style={{
                    color: 'red'
                }}>{this.props.error.message}</p>
            );
        }
        
        let authRedirect = null;
        if (this.props.isAuthenticated) {
            authRedirect = <Redirect to={this.props.authRedirectPath}/>
        }

        return (
            <div className="login-box">
                {authRedirect}
                <div className="login-logo">
                    <a href="/">
                        <img src={Logo} alt="Foodzaps"/>
                    </a>
                </div>
                <div className="login-box-body">
                    <p className="login-box-msg">Sign in to start your session</p>
                    {errorMessage}
                    <form onSubmit={this.loginHandler}>
                        {form}
                        <div className="row">
                            <div className="col-xs-12">
                                <Button classValue="btn btn-primary btn-block btn-flat" disabled={this.state.formIsValid}>SUBMIT</Button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        loading: state.auth.loading,
        error: state.auth.error,
        isAuthenticated: state.auth.isAuthenticated,
        authRedirectPath: state.auth.authRedirectPath
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onAuth: ( email, password ) => dispatch( actions.auth( email, password ) ),
        onSetAuthRedirectPath: () => dispatch(actions.setAuthRedirectPath('/'))
    };
};

export default connect( mapStateToProps, mapDispatchToProps )( Login );